// extracted by mini-css-extract-plugin
export default {"root":"footer_root__FLHLU","inner_wrapper":"footer_inner_wrapper__ag7GX"};